import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthUsersGuard,canManageCustomersAuthGuard,canViewCreateCompAuthGuard,canViewSearchComponentsGuard,canViewSearchNotificationsGuard,canViewSearchSelectionsGuard} from './auth-guard.service';
import { SearchNotificationsComponent } from './views/search-notifications/search-notifications.component'
import { UnderConstructionComponent } from './shared/components/under-construction.component'
import { SearchSelectionLettersComponent} from 'src/app/views/search-selection-letters/search-selection-letters.component'
import { ChangeTestingLocationComponent } from './views/change-testing-location/change-testing-location.component'
import { CreateSelectionsComponent } from './views/create-selections/create-selections.component';
import { SearchComponentsComponent } from './views/search-components/search-components.component'
import { CustomSelectionWebComponent} from './views/custom-selections-web/custom-selections-web.component';
import { ComponentTestingReminderNoticesComponent} from './views/component-testing-reminder-notices/component-testing-reminder-notices.component'
import { CreateSelectionsCustomerComponent} from './views/create-selections-customers/create-selections-customers.component'
import { SearchSelectionsComponent} from './views/search-selections/search-selections.component'
import { GenerateSuspensionNoticesComponent } from './views/generate-suspension-notices/generate-suspension-notices.component';
import { RecordViolationsComponent } from './views/record-violations/record-violations.component'
import { UnauthorizedComponent } from './views/unautorized-component/unauthorised-page.component';

const routes: Routes = [
  {
    path: 'customers',
    canActivate : [canManageCustomersAuthGuard,AuthUsersGuard],
    loadChildren: () => import('./views/customers/customers.module').then(m => m.CustomersModule)
  },
  {
    path: 'search-selection-letters',
    canActivate : [canManageCustomersAuthGuard],
    component: SearchSelectionLettersComponent
  },
  {
    path: 'change-testing-location',
    canActivate : [AuthUsersGuard],
    component: ChangeTestingLocationComponent
  },
  {
    path: 'under-construction',
    canActivate : [AuthUsersGuard],
    component:UnderConstructionComponent
  },
  {
    path: 'create-selections',
    canActivate:[canViewCreateCompAuthGuard,AuthUsersGuard],
    component:CreateSelectionsComponent
  },
  {
    path: 'search-components',
    canActivate:[canViewSearchComponentsGuard,AuthUsersGuard],
    component:SearchComponentsComponent
  },
  {
    path: 'search-notifications',
    canActivate : [canViewSearchNotificationsGuard,AuthUsersGuard],
    component:SearchNotificationsComponent
  },
  {
    path: 'custom-selections',
    canActivate : [AuthUsersGuard],
    component : CustomSelectionWebComponent
  },
  {
    path: 'component-testing-reminder-notices',
    canActivate : [AuthUsersGuard],
    component : ComponentTestingReminderNoticesComponent
  },
  {
    path: 'create-selections-customers',
    canActivate : [AuthUsersGuard],
    component : CreateSelectionsCustomerComponent
  },
  {
    path: 'search-selections',
    canActivate:[canViewSearchSelectionsGuard,AuthUsersGuard],
    component : SearchSelectionsComponent
  },
  {
    path: 'generate-suspension-notices',
    canActivate : [AuthUsersGuard],
    component: GenerateSuspensionNoticesComponent
  },
  {
    path: 'record-violations',
    canActivate : [AuthUsersGuard],
    component: RecordViolationsComponent
  },
  {
    path: '',
    redirectTo: '/customers',
    pathMatch: 'full'
  },
  { path: 'authorized', component: UnauthorizedComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthUsersGuard,AuthUsersGuard,canManageCustomersAuthGuard,canViewSearchNotificationsGuard,canViewSearchComponentsGuard,canViewSearchSelectionsGuard,canViewCreateCompAuthGuard,canViewSearchSelectionsGuard]
})
export class RoutingModule { }
